import { type MutationTree } from 'vuex';

import { type IMandatoryFieldConfigState } from './types';

export const RECEIVE_REFRESH_TIMESTAMP = 'receiveRefreshTimestamp';
export const RECEIVE_COMPLETE = 'receiveComplete';

export const mutations: MutationTree<IMandatoryFieldConfigState> = {
    [RECEIVE_REFRESH_TIMESTAMP](_state, { timestamp }: { timestamp: number }) {
        _state.timestamp = timestamp;
    },
    [RECEIVE_COMPLETE](_state, { complete }: { complete: boolean }) {
        _state.complete = complete;
    }
};
